var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import styles from './TreeSelectOption.module.scss';
import { TreeSelectOptions } from '../../TreeSelectOptions';
import { Checkbox } from '../../../Checkbox/Checkbox';
import { ArrowDown } from '../../../../assets/icons';
var TreeSelectOption = function (_a) {
    var _b;
    var option = _a.option, selected = _a.selected, opened = _a.opened, marked = _a.marked, disabled = _a.disabled, onChange = _a.onChange, onOpenedChange = _a.onOpenedChange;
    var label = option.label, options = option.options;
    var optionIsOpened = opened.includes(option.value);
    var openedOptions = __spreadArray(__spreadArray([], opened, true), [option.value], false);
    var closedOptions = opened === null || opened === void 0 ? void 0 : opened.filter(function (o) { return o !== option.value; });
    var getChildren = function (data) {
        if (data === void 0) { data = []; }
        return data.reduce(function (curr, item) { return __spreadArray(__spreadArray([], curr, true), [item], false); }, []);
    };
    var isOptionSelected = function (o) { return selected.some(function (s) { return s.value === o.value; }); };
    var isAnySelected = (_b = getChildren(options)) === null || _b === void 0 ? void 0 : _b.some(function (o) { return isOptionSelected(o); });
    var isOptionPartial = !!options && isAnySelected;
    var optionToggle = function () {
        if (!isOptionSelected(option))
            return __spreadArray([option], selected, true);
        return selected.filter(function (s) { return s.value !== option.value; });
    };
    var optionsToggle = function () {
        onOpenedChange === null || onOpenedChange === void 0 ? void 0 : onOpenedChange(optionIsOpened ? closedOptions : openedOptions);
    };
    var onOptionClick = function (e) {
        e.stopPropagation();
        if (options)
            return optionsToggle();
        !disabled && onChange(optionToggle());
    };
    var renderOptions = function () {
        if (!options || !optionIsOpened)
            return;
        return (_jsx(TreeSelectOptions, { options: options, selected: selected, opened: opened, marked: marked || isOptionSelected(option), disabled: disabled, className: styles.Options, onChange: onChange, onOpenedChange: onOpenedChange }));
    };
    return (_jsxs("li", __assign({ className: "".concat(styles.Option, " ").concat(disabled ? styles.Disabled : ''), onClick: onOptionClick, "data-testid": 'tree-option' }, { children: [_jsxs("section", __assign({ className: styles.OptionContent }, { children: [_jsxs("div", __assign({ className: styles.OptionName }, { children: [_jsx(Checkbox, { checked: isOptionSelected(option), marked: marked, disabled: disabled, partial: isOptionPartial, onChange: function () { return onChange(optionToggle()); }, className: styles.Checkbox, dataId: 'option-check' }), label] })), options && _jsx(ArrowDown, {})] })), renderOptions()] })));
};
TreeSelectOption.propTypes = {
    selected: PropTypes.arrayOf(PropTypes.any).isRequired,
    opened: PropTypes.arrayOf(PropTypes.any).isRequired,
    marked: PropTypes.bool,
    disabled: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    onOpenedChange: PropTypes.func.isRequired,
};
export { TreeSelectOption };
//# sourceMappingURL=TreeSelectOption.js.map